
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dp/[...slug]",
      function () {
        return require("private-next-pages/dp/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dp/[...slug]"])
      });
    }
  